// @ts-check

class Breadcrumbs extends HTMLElement {
	/** @type {HTMLUListElement | null} */
	#breadcrumbList = null;

	/** @type {ResizeObserver | null} */
	#resizeObserver = null;

	connectedCallback() {
		this.#breadcrumbList = /** @type {HTMLUListElement | null} */ (
			this.querySelector(".js-Breadcrumb-list")
		);

		if (!this.#breadcrumbList) {
			return;
		}

		this.#resizeObserver = new ResizeObserver(this.#fitBreadcrumbs);
		this.#resizeObserver.observe(this.#breadcrumbList);
	}

	disconnectedCallback() {
		this.#resizeObserver?.disconnect();
	}

	#fitBreadcrumbs = () => {
		if (!this.#breadcrumbList) {
			return;
		}

		const breadcrumbs = Array.from(
			this.querySelectorAll(".js-Breadcrumb-item"),
		);

		if (breadcrumbs.length < 2) {
			return;
		}

		const penultimateBreadcrumb = /** @type {HTMLLIElement} */ (
			breadcrumbs[breadcrumbs.length - 2]
		);
		const lastBreadcrumb = /** @type {HTMLLIElement} */ (
			breadcrumbs[breadcrumbs.length - 1]
		);
		const MIN_INLINE_SIZE = 100;

		penultimateBreadcrumb.style.maxInlineSize = "";
		lastBreadcrumb.style.maxInlineSize = "";

		const gap =
			parseFloat(getComputedStyle(this.#breadcrumbList).columnGap) || 0;
		const containerInlineSize = this.#breadcrumbList.clientWidth;
		const penultimateScrollWidth = penultimateBreadcrumb.scrollWidth;
		const lastScrollWidth = lastBreadcrumb.scrollWidth;
		const totalSpaceNeeded = penultimateScrollWidth + lastScrollWidth + gap;

		// if everything fits, we are done
		if (totalSpaceNeeded <= containerInlineSize) {
			return;
		}

		const overflow = totalSpaceNeeded - containerInlineSize;
		const penultimateShrinkRoom = Math.max(
			0,
			penultimateScrollWidth - MIN_INLINE_SIZE,
		);

		// is shrinking the penultimate breadcrumb enough to fit the breadcrumbs
		// into the container?
		if (penultimateShrinkRoom >= overflow) {
			penultimateBreadcrumb.style.maxInlineSize = `${penultimateScrollWidth - overflow}px`;
		} else {
			// if it was not, shrink the penultimate breadcrumb to the minimum and give
			// the remaining space to the last breadcrumb
			penultimateBreadcrumb.style.maxInlineSize = `${MIN_INLINE_SIZE}px`;
			const remainingOverflow = overflow - penultimateShrinkRoom;
			lastBreadcrumb.style.maxInlineSize = `${Math.max(MIN_INLINE_SIZE, lastScrollWidth - remainingOverflow)}px`;
		}
	};
}

if (!customElements.get("finstral-breadcrumbs")) {
	customElements.define("finstral-breadcrumbs", Breadcrumbs);
}
